// Per-workflow node positions for the canvas, stored in localStorage (not in the
// definition) — layout is a view concern and never touches run data.

const KEY = (workflowId) => `orbit:wf_positions:${workflowId}`;

export function loadPositions(workflowId) {
  try {
    const raw = localStorage.getItem(KEY(workflowId));
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function savePositions(workflowId, positions) {
  try {
    localStorage.setItem(KEY(workflowId), JSON.stringify(positions));
  } catch {
    /* localStorage full or disabled — degrade silently */
  }
}
